<template>
  <table class="Table Table--Sticky Table--Stripped bg-white rounded-md shadow mb-8">
    <thead>
    <tr class="TableHeader">
      <th class="py-3.5 px-3"></th>
      <th class="py-3.5 px-3 text-left">{{$t('Name')}}</th>
      <th class="py-3.5 px-3 whitespace-nowrap">{{$t('Uploaded')}}</th>
      <th class="py-3.5 px-3 text-right whitespace-nowrap">{{$t('Actions')}}</th>
    </tr>
    </thead>
    <tbody>
      <file-table-row v-for="(row, index) in list" :key="row.id" :row="row" :rank="index"/>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    list: Array,
    loading: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .Table--Sticky {
    @apply static;
  }
  .Table {
    tr:first-child {
      @apply hidden;
    }
  }
}
</style>
